/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { VirtualTssDTO } from '../model/models';
import { VirtualTssStatusDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AdminDeleteTssRequestParams {
    tssId: string;
    force?: boolean;
}

export class ClsAdminDeleteTssRequestParams {
    tssId: string = undefined;
    force?: boolean = undefined;
}

export interface CreateCspAccountRequestParams {
    tssId: string;
}

export class ClsCreateCspAccountRequestParams {
    tssId: string = undefined;
}

export interface SynchronizeCspAccountRequestParams {
    tssId: string;
}

export class ClsSynchronizeCspAccountRequestParams {
    tssId: string = undefined;
}

export interface UpdateTssStatusRequestParams {
    tssId: string;
    ifMatch: string;
    virtualTssStatusDTO: VirtualTssStatusDTO;
    force?: boolean;
}

export class ClsUpdateTssStatusRequestParams {
    tssId: string = undefined;
    ifMatch: string = undefined;
    virtualTssStatusDTO: VirtualTssStatusDTO = undefined;
    force?: boolean = undefined;
}

export interface UploadApplicationLogRequestParams {
    tssId: string;
}

export class ClsUploadApplicationLogRequestParams {
    tssId: string = undefined;
}


export interface AdminTssApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Admin Delete an existing TSS entity
     * Delete an existing TSS entity 
* @param requestParameters
     */
    adminDeleteTss(requestParameters: AdminDeleteTssRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Create CSP Account
     * Request a new CSP account from BDR when TSS doesn\&#39;t have any CSP account yet. 
* @param requestParameters
     */
    createCspAccount(requestParameters: CreateCspAccountRequestParams, extraHttpRequestParams?: any): Observable<VirtualTssDTO>;

    /**
     * Synchronize CSP Account
     * Synchronize CSP account with BDR. 
* @param requestParameters
     */
    synchronizeCspAccount(requestParameters: SynchronizeCspAccountRequestParams, extraHttpRequestParams?: any): Observable<VirtualTssDTO>;

    /**
     * Update a virtual TSS status
     * Update a virtual TSS status
* @param requestParameters
     */
    updateTssStatus(requestParameters: UpdateTssStatusRequestParams, extraHttpRequestParams?: any): Observable<VirtualTssDTO>;

    /**
     * Trigger Application Log-File upload
     * Trigger Application Log-File upload for the FCC associated to the specified TSS ID. 
* @param requestParameters
     */
    uploadApplicationLog(requestParameters: UploadApplicationLogRequestParams, extraHttpRequestParams?: any): Observable<{}>;

}
